//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { fetch, store, update, _STATUS, _ADTYPE, _POSITION } from '@/apis/advertisement'

import { oss_files } from '@/apis/config'


export default {
    components: {
    },
    data() {
        //表單校驗
        const rules = {
            adName: [{ required: true, message: '請輸入名稱！' }],
            imageUrl: [{ required: true, message: '請上傳封面圖！' }],
            displayPosition: [{ required: true, message: '請選擇渲染位置' }],
            adType: [{ required: true, message: '請選擇廣告類型' }],

        };
        const formData = {
            adName: "",
            status: "1",
            redirectUrl: "",
            adType: "1",
            imageUrl: "",
            sortOrder: '0',
            displayPosition: '1',
            positionDesc: "",

        };
        return {
            config: {
                status: [],
                position: [],
                adType: [],
            },
            id: 0,
            fileLoading: false,
            businessHours: '',
            //是否為管理員
            isAdmin: false,
            spinning: false,
            formData,
            rules,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
            fileList: [],
            previewImage: undefined,
            previewVisible: false
        }
    },
    async mounted() {
        this.isAdmin = false;
        this.id = this.$route.params.id;
        await this.onPageConfig();
        if (this.id > 0) {
            await this.onPageLoad();
        }
    },
    methods: {
        async onPageConfig() {
            try {
                let _status = [], _position = [], _adtype = [];

                Object.keys(_STATUS).forEach(value => {
                    _status.push({
                        id: value,
                        name: _STATUS[value]
                    })
                });
                this.config.status = _status;

                Object.keys(_ADTYPE).forEach(value => {
                    _adtype.push({
                        id: value,
                        name: _ADTYPE[value]
                    })
                });
                this.config.adType = _adtype;

                Object.keys(_POSITION).forEach(value => {
                    _position.push({
                        id: value,
                        name: _POSITION[value]
                    })
                });
                this.config.position = _position;

            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad() {
            try {
                const res = await fetch(this.id);
                if (res.code == 0) {
                    this.formData = res.data;
                    this.formData.adType = this.formData.adType.toString();
                    this.formData.displayPosition = this.formData.displayPosition.toString();
                    this.formData.status = this.formData.status.toString();
                    this.onLoadFile();
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        onLoadFile() {
            function getFileName(path) {
                const regex = /([^\/\\]+)$/;
                const match = regex.exec(path);
                if (match) {
                    return match[1];
                } else {
                    return null;
                }
            }
            const url = this.formData.imageUrl;
            if (url) {
                this.fileList = [{
                    uid: '-1',
                    name: getFileName(url),
                    status: 'done',
                    url: url,
                    thumbUrl: url,
                }]
            }
        },

        //圖片上傳
        async handleFileChange({ fileList }) {
            if (fileList.length > 0) {
                // 過濾掉非圖片文件
                const validFiles = fileList.filter(file =>
                    file.type?.startsWith('image/') ||
                    (file.originFileObj && file.originFileObj.type.startsWith('image/'))
                );
                try {
                    this.fileLoading = true;
                    const formData = new FormData();
                    formData.append('file', validFiles[0].originFileObj);
                    const res = await oss_files('ifBG', formData);
                    console.log(`output->res`, res)

                    if (res.code == 0) {
                        this.formData.imageUrl = res.data;
                        this.fileList = validFiles;
                        this.$refs.businessHoursItem.clearValidate();

                    } else {
                        this.$message.error(res.msg);
                    }
                    console.log(`output->this.formData`, this.formData)
                } catch (error) {
                    this.$message.error(error.message);
                } finally {
                    this.fileLoading = false;
                }
            } else {
                this.fileList = fileList;
                this.formData.imageUrl = "";
            }
        },
        async handleFilePreview(file) {
            function getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            }
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handlePreviewCancel() {
            this.previewVisible = false;
        },


        handleOnFormValidate(e, v) {
            e.preventDefault();
            console.log('onFormValidate', v);
            this.$refs.form.validate(valid => {
                console.log(valid);
                if (valid) {
                    this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        async onSubmit(e) {
            let formFunction;
            const form = { ...this.formData };
            if (this.id > 0) {
                form.id = this.id;
                formFunction = update;
            } else {
                formFunction = store;
            }
            try {
                this.spinning = true;
                const res = await formFunction(form);
                if (res.code == 0) {
                    this.$message.success('提交完成');
                    this.$router.push('/ad');
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
